import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { MaterialModule } from '../material/material.module';
import { DesignComponent } from './design/design.component';
import { PlansComponent } from './plans/plans.component';
import { FooterComponent } from './footer/footer.component';
import { FormsModule } from '@angular/forms';
import { MatFormFieldComponent } from './mat-form-field/mat-form-field.component';
import { ContactComponent } from './contact/contact.component';
import { GoogleMapsModule } from '@angular/google-maps'
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import { RecaptchaModule } from 'ng-recaptcha';
import { DynamicImageComponent } from './dynamic-image/dynamic-image.component';
import { DirectiveModule } from '../directives/directive.module';
import { PipeModule } from '../pipes/pipe.module';
import { CarouselComponent } from './carousel/carousel.component';
import { OurEmployeesComponent } from './our-employees/our-employees.component';
import { ProjectComponent } from './project/project.component';
@NgModule({
  declarations: [
    HeaderComponent,
    DesignComponent,
    PlansComponent,
    FooterComponent,
    MatFormFieldComponent,
    CarouselComponent,
    ContactComponent,
    NotFoundPageComponent,
    OurEmployeesComponent,
    DynamicImageComponent,
    ProjectComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    GoogleMapsModule,
    RouterModule,
    RecaptchaModule,
    DirectiveModule,
    PipeModule
  ],
  exports:[
    ProjectComponent,
    HeaderComponent,
    DesignComponent,
    PlansComponent,
    CarouselComponent,
    FooterComponent,
    MatFormFieldComponent,
    ContactComponent,
    NotFoundPageComponent,
    DynamicImageComponent,
    OurEmployeesComponent,
  ]
})
export class SharedModule { }
